<a
  (click)="goBack()"
  class="arrow arrow-left"
  [translate]="
    migration
      ? 'add-account/whatsapp-cloud-api/pre-qualify/back-to-account'
      : 'add-account/whatsapp-cloud-api/pre-qualify/back-to-accounts'
  "></a>

<mat-card>
  <mat-card-title>{{ title }}</mat-card-title>
  <mat-card-subtitle>
    {{ 'add-account/whatsapp-cloud-api/pre-qualify/subtitle' | translate }}&nbsp;
    <a href="https://business.whatsapp.com/whatsapp-vs-whatsapp-business" rel="noopener noreferrer" target="_blank">
      {{ 'add-account/whatsapp-cloud-api/pre-qualify/link' | translate }}&nbsp;<mat-icon>open_in_new</mat-icon>
    </a>
  </mat-card-subtitle>
  <mat-card-content>
    <mat-stepper linear #stepper>
      <mat-step [stepControl]="accountTypeControl">
        <ng-template matStepLabel>
          {{ 'add-account/whatsapp-cloud-api/pre-qualify/steps/account-type/title' | translate }}
        </ng-template>
        <ng-template matStepContent>
          <app-step-account-type [migration]="migration" [control]="accountTypeControl"></app-step-account-type>
        </ng-template>
      </mat-step>

      <mat-step [stepControl]="(migration && phoneNumberGroup) || phoneNumberGroup.get('phoneNumberStep')">
        <ng-template matStepLabel>
          {{ 'add-account/whatsapp-cloud-api/pre-qualify/steps/phone-number/title' | translate }}
        </ng-template>
        <ng-template matStepContent>
          <app-step-phone-number
            [form]="phoneNumberGroup"
            [migration]="migration"
            (nextStep)="stepper.next()"></app-step-phone-number>
        </ng-template>
      </mat-step>

      <mat-step [stepControl]="connectAccountControl">
        <ng-template matStepLabel>
          {{ 'add-account/whatsapp-cloud-api/pre-qualify/steps/connect-account/title' | translate }}
        </ng-template>
        <ng-template matStepContent>
          <app-step-connect-account
            [form]="connectAccountGroup"
            [origin]="origin"
            [migration]="migration"
            [siteId]="site?.id"
            (statusChanged)="whatsappCloudApiLoginStatusChanged($event)"></app-step-connect-account>
        </ng-template>
      </mat-step>

      <mat-step>
        <ng-template matStepLabel>
          {{ 'add-account/whatsapp-cloud-api/pre-qualify/steps/payment-line/title' | translate }}
        </ng-template>
        <ng-template matStepContent>
          <app-step-payment-line
            [migration]="migration"
            [hasWarnings]="
              connectAccountControl.value === WhatsappCloudApiLoginEventEnum.MIGRATED_WITH_LIMITATIONS
            "></app-step-payment-line>
        </ng-template>
      </mat-step>

      <ng-template matStepperIcon="edit">
        <mat-icon>check</mat-icon>
      </ng-template>
    </mat-stepper>
  </mat-card-content>
</mat-card>
